export const addressComponent = (items, component) => {
  const matching = items.filter((item) => item.types.includes(component));
  return matching.length > 0 ? matching[0].long_name : "";
};
